/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { InstitutionGridDto } from './InstitutionGridDto';
import {
    InstitutionGridDtoFromJSON,
    InstitutionGridDtoFromJSONTyped,
    InstitutionGridDtoToJSON,
} from './InstitutionGridDto';

/**
 * 
 * @export
 * @interface InstitutionGridDtoPaginatedResults
 */
export interface InstitutionGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof InstitutionGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<InstitutionGridDto>}
     * @memberof InstitutionGridDtoPaginatedResults
     */
    results?: Array<InstitutionGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof InstitutionGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the InstitutionGridDtoPaginatedResults interface.
 */
export function instanceOfInstitutionGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstitutionGridDtoPaginatedResultsFromJSON(json: any): InstitutionGridDtoPaginatedResults {
    return InstitutionGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function InstitutionGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(InstitutionGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function InstitutionGridDtoPaginatedResultsToJSON(value?: InstitutionGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(InstitutionGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

